import React, { FC, ReactElement } from 'react'
import styles from './GradientText.module.css'
import classNames from 'classnames'

const GradientText: FC<{ classNames?: string; children: React.ReactNode }> = (
	props
): ReactElement => {
	return (
		<div className={classNames(styles.root, { [(props.classNames as any)]: !!props.classNames })}>
			{props.children}
		</div>
	)
}

export default GradientText
